module.exports = __webpack_public_path__ + "img/xx-icon.cf701c54.svg";